$la-gutter-padding: 0.5rem;

.la-akoma-ntoso-with-gutter {
  display: flex;
  flex-direction: row;

  &> la-akoma-ntoso {
    flex: 80%;
    max-width: 80%;
    position: relative;
    padding-right: $la-gutter-padding;
  }

  &> la-gutter {
    flex: 20%;
    max-width: 20%;
    position: relative;
    overflow-y: hidden;

    background-color: rgba(0, 0, 0, 0.05);
    padding-left: $la-gutter-padding;
    padding-right: $la-gutter-padding;
  }
}

la-gutter > la-gutter-item {
  position: absolute;
  left: 2 * $la-gutter-padding;
  width: calc(100% - 3 * $la-gutter-padding);
  transition: top ease-out 100ms, left ease-out 100ms;
  z-index: 2;

  &[active] {
    left: $la-gutter-padding;
    z-index: 3;
  }
}
